import AbstractEntity, {AbstractEntityFields} from "~/ts/library/AbstractEntity";
import PlatformEvent from "~/cabinet/ts/data/events/PlatformEvent";
import EventPlatformAuth from "~/cabinet/ts/data/events/EventPlatformAuth";
import AbstractActionDescription from "~/cabinet/ts/data/events/AbstractActionDescription";

export default class EventPlatform extends AbstractEntity {
    public id!: string;
    public descr!: string;
    public icon!: string;
    public color!: string;
    //public types: EventType[];
    //public events: PlatformEvent[];
    public authList!: EventPlatformAuth[]

    protected getFields(): AbstractEntityFields {
        return {
            blockTypes: AbstractActionDescription,
            events: PlatformEvent,
            authList: EventPlatformAuth
        };
    }

    protected isFreezeObject(): boolean {
        return true;
    }
}